module.exports = __webpack_public_path__ + "static/media/ines_santos.3de3ca02.jpg";